module.exports = __webpack_public_path__ + "img/arrowLeft.432c8370.svg";